import { Action, Dispatch } from 'redux'
import { updateModalHeaderAction } from 'reducks/modal/actions'

const updateModalHeader = (title: string, description = '') => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(updateModalHeaderAction(description, title))
  }
}

export default updateModalHeader
